/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAddressesResponseItems
 */
export interface FindAddressesResponseItems {
    /**
     * 
     * @type {number}
     * @memberof FindAddressesResponseItems
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FindAddressesResponseItems
     */
    anr: string;
    /**
     * 
     * @type {string}
     * @memberof FindAddressesResponseItems
     */
    icon: string;
    /**
     * 
     * @type {string}
     * @memberof FindAddressesResponseItems
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FindAddressesResponseItems
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof FindAddressesResponseItems
     */
    street?: string;
}

export function FindAddressesResponseItemsFromJSON(json: any): FindAddressesResponseItems {
    return FindAddressesResponseItemsFromJSONTyped(json, false);
}

export function FindAddressesResponseItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAddressesResponseItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'anr': json['anr'],
        'icon': json['icon'],
        'name': json['name'],
        'city': json['city'],
        'street': !exists(json, 'street') ? undefined : json['street'],
    };
}

export function FindAddressesResponseItemsToJSON(value?: FindAddressesResponseItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'anr': value.anr,
        'icon': value.icon,
        'name': value.name,
        'city': value.city,
        'street': value.street,
    };
}


